const STORAGE_KEY = 'your-search-panels';
const DEFAULT_LAYOUT = [30, 70];

/**
 * Loads the saved search panel layout from localStorage.
 * Falls back to default if not found or invalid.
 * @returns {number[]}
 */
export const loadSearchLayout = () => {
    try {
        const sizes = localStorage.getItem(STORAGE_KEY);
        return sizes ? JSON.parse(sizes) : DEFAULT_LAYOUT;
    } catch {
        return DEFAULT_LAYOUT;
    }
};

/**
 * Saves the search panel layout to localStorage.
 * @param {number[]} sizes
 */
export const saveSearchLayout = (sizes) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sizes));
};
